<template>
  <AquariumDetail :demoAquarium="demoAquarium" />
</template>

<script>
import AquariumDetail from './AquariumDetail.vue';

export default {
  name: 'AquariumDemo',
  components: { AquariumDetail },
  data() {
    return {
      demoAquarium: {
        id: 1,
        name: 'Waterbox Cube 20 Demo',
        description: '20 gallon mixed reef with soft and hard corals and two clownfish',
        public_link: 'https://example.com/demo',
        image_url: 'https://reeflendar.com/uploads/images/f83a37b2bb964236a865fc67118431eb.jpg',
        notes: 'Demo notes',
        images: [
          { id: 1, url: 'https://reeflendar.com/uploads/images/37421b5b51854578b92e922520afbe05.jpg' },
          { id: 2, url: 'https://reeflendar.com/uploads/images/069783ca90074e70a82e064dfbd1add0.jpg' },
          { id: 3, url: 'https://reeflendar.com/uploads/images/319e2250b5094c36b281965649ffe41c.jpg' },
          { id: 4, url: 'https://reeflendar.com/uploads/images/f60e382902df433095237978e9046d5c.jpg' },
          { id: 5, url: 'https://reeflendar.com/uploads/images/9aa9426203114f76b0f3cb9fb176e8b1.jpg' },
          { id: 6, url: 'https://reeflendar.com/uploads/images/f83a37b2bb964236a865fc67118431eb.jpg' },
          { id: 7, url: 'https://reeflendar.com/uploads/images/37305a4a5475424fba3fdfdebc43be6a.jpg' },
          { id: 8, url: 'https://reeflendar.com/uploads/images/b67a4176efea4e3a85398bc79b003143.jpg' },
          { id: 9, url: 'https://reeflendar.com/uploads/images/86cd636e40944b739fa6e7c464991dab.jpg' },
        ],
        logs: [
          { id: 1, timestamp: '2025-06-21 10:30 AM', temperature: 78, ph: 8.1, salinity: 1.025, note: 'All good, calibrated salinity meter', ammonia: 0.1, nitrite: 0.02, nitrate: 5, phosphase: 0.03, calcium: 420, alkalinity: 8.5, magnesium: 1350 },
          { id: 2, timestamp: '2025-06-20 10:00 PM', temperature: 77, ph: 8.0, salinity: 1.024, note: '5 gallon water change', ammonia: 0.05, nitrite: 0.01, nitrate: 4, calcium: 415, alkalinity: 8.3 },
          { id: 3, timestamp: '2025-06-19 9:00 PM', temperature: 76, salinity: 1.023, nitrate: 6, magnesium: 1320 },
          { id: 4, timestamp: '2025-06-18 9:00 PM', temperature: 78, salinity: 1.025, note: 'No pH reading', phosphase: 0.04, calcium: 425 },
          { id: 5, timestamp: '2025-06-16 9:30 PM', temperature: 79, ph: 8.2, ammonia: 0.08, nitrite: 0.02, note: 'pH meter was calibrated' },
          { id: 6, timestamp: '2025-06-15 11:00 AM', temperature: 77, nitrate: 7, alkalinity: 8.7, note: 'Added new coral frags' },
          { id: 7, timestamp: '2025-06-14 12:00 PM', temperature: 76, ph: 8.0, note: 'Replaced UV bulb', magnesium: 1340 },
          { id: 8, timestamp: '2025-06-13 10:00 AM', temperature: 78, ph: 8.1, salinity: 1.025, ammonia: 0.1, nitrite: 0.02, nitrate: 5, phosphase: 0.03, calcium: 420, alkalinity: 8.5, magnesium: 1350 },
          { id: 9, timestamp: '2025-06-11 9:00 PM', temperature: 77, ph: 8.0, salinity: 1.024, note: 'Water change', ammonia: 0.05, nitrite: 0.01, nitrate: 4, calcium: 415, alkalinity: 8.3 },
          { id: 10, timestamp: '2025-06-09 9:00 PM', temperature: 76, salinity: 1.023, nitrate: 6, magnesium: 1320 },
          { id: 11, timestamp: '2025-06-08 9:00 PM', temperature: 78, salinity: 1.025, note: 'No pH reading', phosphase: 0.04, calcium: 425 },
          { id: 12, timestamp: '2025-06-07 9:30 PM', temperature: 79, ph: 8.2, ammonia: 0.08, nitrite: 0.02, note: 'GHA was scrubbed off a ton of rocks with this waterchange' },
        ],
      },
    };
  },
};
</script>

<script setup>
import { useHead } from '@vueuse/head';

useHead({
  title: 'Reeflendar.com - Demo Aquarium',
  meta: [
    { name: 'description', content: 'Demo aquarium for Reeflendar.' },
    { name: 'keywords', content: 'aquarium, demo, reef tank' },
  ],
});
</script>